export default {"src":"/_next/static/media/remediation-support.bf67e33c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};